export const READ_ONLY_ROLE = "farm-user:readonly";
